import { useCallback, useState } from "react";

import AgentTraceButton from "@/components/buttons/AgentTraceButton";
import ChatContainer from "@/components/chat/ChatContainer";
import { ChatMessage } from "@/components/chat/types";
import { mapToRenderMessage } from "@/components/chat/utils";
import { UserFromApi } from "@/types/user";

import useModal from "../useModal";
import useAdminChatHistory from "./useAdminChatHistory";

export interface UseReadOnlyChatModalProps {
  user: UserFromApi | undefined;
}

const useReadOnlyChatModal = ({ user }: UseReadOnlyChatModalProps) => {
  const { loading, getAdminChatById } = useAdminChatHistory();
  const [title, setTitle] = useState<string>();
  const [messages, setChatMessages] = useState<ChatMessage[]>([]);
  const [conversationId, setConversationId] = useState("");

  const { toggle, ModalComponent } = useModal({
    title: loading ? `Loading Chat...` : `${title ?? "..."} (Read-Only)`,
    size: "max",
    content: <ChatContainer messages={messages} loading={loading} />,
    additionalActions: (
      <AgentTraceButton
        userId={user?.userId ?? ""}
        conversationId={conversationId}
      />
    ),
  });

  const handleToggle = useCallback(
    async (id: string) => {
      setChatMessages([]);
      setConversationId(id);
      setTitle(undefined);
      toggle();
      if (user) {
        const response = await getAdminChatById(user.userId, id);

        if (response) {
          const { title, messages } = response;
          setTitle(title);
          setChatMessages(messages.map(mapToRenderMessage(user)));
        }
      }
    },
    [user]
  );

  return {
    toggle: handleToggle,
    ModalComponent,
  };
};

export default useReadOnlyChatModal;
